export const MARKER_LOCATION_DEFAULT_SIZE = {
  width: 35,
  height: 40,
};
export const MARKER_LOCATION_SCALE = {
  DEFAULT: 1,
};
